import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  corpoFormulario: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
}))
